import { ImageBannerData, PromotionDisplayType } from "src/types/graphql.d";

const TIMER_PROMOTION_TYPES: PromotionDisplayType[] = [
  PromotionDisplayType.LightningDeal,
  PromotionDisplayType.FlashSale,
];

/**
 * Filters expired timer based promotional blocks
 * @param banners - Array of image banner data
 * @returns Filtered array with expired timer promotions removed for Lightning Deal and FlashSale
 */
export function filterExpiredImageBannerDeals(
  banners: ImageBannerData[]
): ImageBannerData[] {
  if (!banners || banners.length === 0) {
    return [];
  }

  const now = Date.now();

  return banners.filter((banner) => {
    const displayType = banner?.display_type as PromotionDisplayType;
    const isTimerPromotion = TIMER_PROMOTION_TYPES.includes(displayType);

    if (!isTimerPromotion) {
      return true;
    }

    // Add a time buffer to expire and show the blocks that is set to same start and end dates
    const startDate = new Date(banner.start_date).getTime() - 1000;
    const endDate = new Date(banner.end_date).getTime() - 1000;

    return startDate <= now && endDate > now;
  });
}
